import { fetchConfigs } from '@services/config.service';
import type { Configuration as MsalConfig } from '@azure/msal-browser';
import { LocalStorageKey } from '@constants/storage-keys.constants';
import { msalLoggerCallback } from '@/AppInsights';

export const msalConfig : () => Promise<MsalConfig>= async () => {
	const response = await fetchConfigs();
	const msal_config = response?.data?.MSAL_CONFIG;
	localStorage.setItem(LocalStorageKey.CONFIG_KEY, JSON.stringify(response.data));

	return {
		auth: {
			clientId: msal_config?.msal?.auth?.clientId,
			authority: msal_config?.msal?.auth?.authority,
			knownAuthorities: msal_config?.msal?.auth?.knownAuthorities,
			redirectUri: msal_config?.msal?.auth?.redirectUri,
			postLogoutRedirectUri: msal_config?.msal?.auth?.postLogoutRedirectUri,
		},
		cache: {
			cacheLocation: msal_config?.cache?.cacheLocation,
			storeAuthStateInCookie: msal_config?.cache?.storeAuthStateInCookie,
		},
		system: {
			allowRedirectInIframe: true,
			iframeHashTimeout: msal_config?.system?.iframeHashTimeout ?? 4000,
			loggerOptions: {
				loggerCallback: msalLoggerCallback
			},
		},
	};
};

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit:
 * https://docs.microsoft.com/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
export const loginRequest = async () => {
	const appConfig = JSON.parse(localStorage.getItem(LocalStorageKey.CONFIG_KEY) || '{}');
	const msal_config = appConfig?.MSAL_CONFIG || (await fetchConfigs())?.data?.MSAL_CONFIG;

	return {
		scopes: msal_config?.apiConfig?.scopes,
		uri: msal_config?.apiConfig?.uri,
	};
};
